import React from 'react';
import { BadgeCheckIcon, ChevronLeftIcon, MapPinIcon, Share2Icon, TrainFrontIcon } from 'lucide-react';
import { StatusBar } from '../phone/StatusBar';
import { appEvents } from '../../data/appEvents';
export function EventScreen() {
  const event = appEvents[0];
  return <div className="relative flex h-full flex-col" data-id="element-342" data-mp="f9ivx9n9ieab">
      <div className="relative h-44 shrink-0" data-id="element-343" data-mp="fa13h2fdkexj">
        <img src={event.image} alt="" className="h-full w-full object-cover" data-id="element-344" data-mp="3np2n834dhmmq" />
        <div className="absolute inset-0 bg-black/25" data-id="element-345" data-mp="3nr5ndfz8ow56" />
        <div className="absolute inset-x-0 top-0" data-id="element-346" data-mp="3iraw3bbjy4jl">
          <StatusBar tone="light" data-id="element-347" data-mp="1i4eh7906l5d" />
        </div>
        <div className="absolute inset-x-4 top-9 flex justify-between" data-id="element-348" data-mp="1ivyrlx5gwgc">
          <span className="grid h-8 w-8 place-items-center rounded-full bg-white/90" data-id="element-349" data-mp="3snw0pvjntdmw">
            <ChevronLeftIcon className="h-4 w-4" data-id="element-350" data-mp="1cx14ajd0heds" />
          </span>
          <span className="grid h-8 w-8 place-items-center rounded-full bg-white/90" data-id="element-351" data-mp="1czdwrqgeb753">
            <Share2Icon className="h-3.5 w-3.5" data-id="element-352" data-mp="17xomid0zyxi2" />
          </span>
        </div>
      </div>

      <div className="relative -mt-6 flex-1 rounded-t-[1.75rem] bg-canvas px-4 pt-4" data-id="element-353" data-mp="3s56k7cpb5fv6">
        <span className="rounded-full bg-mint-soft px-2 py-0.5 text-[9px] font-bold text-forest" data-id="element-354" data-mp="yc3k6i4e2sz">{event.category}</span>
        <p className="mt-2 font-display text-[19px] font-extrabold leading-tight tracking-tight" data-id="element-355" data-mp="5yzz95han7tj">{event.title}</p>
        <p className="mt-1 flex items-center gap-1 text-[10px] text-muted" data-id="element-356" data-mp="9xz83165boq9">
          <MapPinIcon className="h-3 w-3" data-id="element-357" data-mp="39grtkqiwk3uw" />
          {event.city} · {event.date}
        </p>

        <div className="mt-3 flex items-center gap-2.5 border-y border-line py-2.5" data-id="element-358" data-mp="3ef35d6srcofr">
          <span className="grid h-7 w-7 place-items-center rounded-full bg-ink text-[9px] font-bold text-white" data-id="element-359" data-mp="3ieu0tnt8bsqm">HL</span>
          <div className="flex-1" data-id="element-360" data-mp="3n86cyygq272h">
            <p className="text-[10.5px] font-bold" data-id="element-361" data-mp="2qopal8isgbhh">Event organizer</p>
            <p className="flex items-center gap-1 text-[9px] text-muted" data-id="element-362" data-mp="2qogxbfir745r">
              <BadgeCheckIcon className="h-3 w-3 text-forest" data-id="element-363" data-mp="2uozqpe0aoia2" />
              Claimed on AVEGA
            </p>
          </div>
        </div>

        <p className="mt-2.5 text-[10px] leading-snug text-muted" data-id="element-364" data-mp="1thdt85opqfa">
          Interior, garden and lifestyle brands under one roof, with live actions during the fair.
        </p>

        <div className="mt-2.5 flex items-center gap-2.5 rounded-xl bg-white p-2.5 ring-1 ring-line" data-id="element-365" data-mp="bku620veailu">
          <TrainFrontIcon className="h-4 w-4 text-forest" data-id="element-366" data-mp="6nc5axrj79ox" />
          <div data-id="element-367" data-mp="3f1kiaxhklrvz">
            <p className="text-[10px] font-bold" data-id="element-368" data-mp="3f35awhkbr0r7">Getting there</p>
            <p className="text-[9px] text-muted" data-id="element-369" data-mp="3a3spm193q1qq">Public transport and parking</p>
          </div>
        </div>

        <div className="leaf-md mt-2.5 bg-forest p-3.5 text-white" data-id="element-370" data-mp="3o3ajuw56277h">
          <p className="flex items-center gap-1.5 text-[9px] font-bold text-mint" data-id="element-371" data-mp="3k1gliuig1fah">
            <span className="h-1.5 w-1.5 rounded-full bg-mint" data-id="element-372" data-mp="3k3jm28h82qtg" />
            Active action
          </p>
          <div className="mt-1.5 flex items-end justify-between gap-2" data-id="element-373" data-mp="13envwr1scnup">
            <div data-id="element-374" data-mp="zaogkbs8rv2x">
              <p className="font-display text-[15px] font-bold leading-tight" data-id="element-375" data-mp="zdanc97b66k3">Win a smartphone</p>
              <p className="mt-0.5 text-[9px] text-white/65" data-id="element-376" data-mp="16wtre3bt10l6">Electronics brand · 3 questions</p>
            </div>
            <span className="rounded-full bg-mint px-3 py-1.5 text-[10px] font-bold text-forest-deep" data-id="element-377" data-mp="1brh7pewnmooo">Start</span>
          </div>
        </div>
      </div>
    </div>;
}